export type Situacao = 'Novo' | 'Em andamento' | 'Finalizado' | 'Em coleta (Rascunho)' | 'Sincronizado' | 'Enviado ao Estado';

export const normalizeRawStatus = (rawStatus: any): string =>
  String(rawStatus ?? '').trim().toUpperCase().replace(/[\s-]+/g, '_');

export const mapCollectionToSituacao = (collectionData: any): Situacao => {
  const rawStatus =
    collectionData?.status ?? collectionData?.collection_status ?? collectionData?.latest_status?.code ?? collectionData?.status_code ?? '';

  const s = normalizeRawStatus(rawStatus);
  const editable = Boolean(collectionData?.editable);

  const statusMap: Record<string, Situacao> = {
    EM_COLETA_RASCUNHO: 'Em coleta (Rascunho)',
    RASCUNHO: 'Em coleta (Rascunho)',
    EM_COLETA: 'Em andamento',
    EM_ANDAMENTO: 'Em andamento',
    SINCRONIZADO: 'Sincronizado',
    ENVIADO_AO_ESTADO: 'Enviado ao Estado',
    ENVIADO: 'Enviado ao Estado',
    FINALIZADO: 'Finalizado',
  };

  if (editable) return 'Em coleta (Rascunho)';
  if (s in statusMap) return statusMap[s];
  return s.startsWith('EM_') ? 'Em andamento' : 'Finalizado';
};

export default mapCollectionToSituacao;
